import { render, staticRenderFns } from "./UpdateDocumentModal.vue?vue&type=template&id=8cbf7940"
import script from "./UpdateDocumentModal.vue?vue&type=script&lang=ts"
export * from "./UpdateDocumentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports